module.exports = __webpack_public_path__ + "assets/images/slope-condos/desktop.svg?v=11a26670";